import { Image } from 'antd-mobile';
import gblogo1 from '@/assets/images/gblogo_1.webp';
import gblogo2 from '@/assets/images/gblogo_2.webp';
import gblogo3 from '@/assets/images/gblogo_3.webp';
import gblogo4 from '@/assets/images/gblogo_4.webp';
import gblogo5 from '@/assets/images/gblogo_5.webp';
import gblogo6 from '@/assets/images/gblogo_6.webp';
// import appGold from '@/assets/images/poster/app_gold.svg';
import { getOperationSiteList } from '@/api/servico';
import { useEffect, useState } from 'react';
import { getS3Url } from '@/utils';
const Brand = ({ appConfig }) => {
  const defaultValue = {
    brands: [
      { id: 1, url: gblogo1 },
      { id: 2, url: gblogo2 },
      { id: 3, url: gblogo3 },
      { id: 4, url: gblogo4 },
      { id: 5, url: gblogo5 },
      { id: 6, url: gblogo6 }
    ]
  };
  const handleMedia = val => {
    if (val.goUrl) {
      window.open(val.goUrl);
    }
  };
  const downloadConfig =
    JSON.stringify(appConfig) != '{}' ? appConfig : defaultValue;

  const [noticeContent, setNoticeContent] = useState('');
  //获取轮播消息
  const queryOperationSiteList = async () => {
    const { code, data } = await getOperationSiteList();
    if (code === 200) {
      setNoticeContent(data[0].content);
    }
  };
  useEffect(() => {
    queryOperationSiteList();
  }, []);
  return (
    <>
      <div className="panel noTitleBg" id="brands">
        <div className="gpanel-more-frame">
          <img className="group-icon-last" src={getS3Url('home/par.png')} />
          <span className="group-title">Parceiros</span>
        </div>
        <div className="container">
          {downloadConfig?.brandList?.map(item => (
            <div key={item.id} className="item gpanel-bottom-item">
              <div className="gpanel-bottom-item-content">
                <Image src={item.imgUrl} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="panel sdpromotion-frame-type1 noTitleBg">
        <div className="gpanel-more-frame">
          <img
            className="group-icon-last"
            src={getS3Url('home/official.png')}
          />
          <span className="group-title">Canal Oficial</span>
        </div>

        <div className="sdpromotion-content">
          {downloadConfig?.mediaList?.map((item, index) => (
            <div
              className="div-link"
              key={index}
              onClick={() => handleMedia(item)}
            >
              <Image src={item.imgUrl} />
            </div>
          ))}
        </div>
      </div>

      <div className="desc-content mb-[93px]">
        <div className="desc-content-name">{downloadConfig?.siteName}</div>
        <div className="desc-content-text">
          <p className="w-full break-words">{noticeContent}</p>
          {/* <p>
            1. Este produto é para uso de usuários maiores de 18 anos e é
            destinado apenas para fins de entretenimento.
            <br />
            2. este jogo contém compras noapp.
            <br />
            3. O fato de um jogador jogar ou ganhar em um jogo de apostas
            sociais não significa que ele ganhará em apostas com dinheiro real e
            jogos relacionados no futuro.
          </p> */}
        </div>
        <div className="desc-content-tips">
          ©2024 {downloadConfig?.siteName}.Todos os direitos reservados. 18+
        </div>
        <div className="desc-content-version">ver:1.1.5(1A)</div>
      </div>
    </>
  );
};

export default Brand;
